import { SortDescriptor } from "react-aria-components";

import { compareModuleVersionValues, toModuleVersionSortDirection } from "../../helpers";
import { MODULE_VERSION_PROVIDER_DEPENDENCIES_COLUMN_ID } from "./constants";
import { ModuleVersionProviderDependencyRow } from "./types";

export const sortProviderDependencies = (
  dependencies: ModuleVersionProviderDependencyRow[],
  sortDescriptor: SortDescriptor
) => {
  const direction = toModuleVersionSortDirection(sortDescriptor);

  switch (sortDescriptor.column) {
    case MODULE_VERSION_PROVIDER_DEPENDENCIES_COLUMN_ID.NAME:
      return [...dependencies].sort((a, b) => compareModuleVersionValues(a.id, b.id, direction));
    case MODULE_VERSION_PROVIDER_DEPENDENCIES_COLUMN_ID.VERSION:
      return [...dependencies].sort((a, b) =>
        compareModuleVersionValues(a.version, b.version, direction)
      );
    case MODULE_VERSION_PROVIDER_DEPENDENCIES_COLUMN_ID.SOURCE:
      return [...dependencies].sort((a, b) =>
        compareModuleVersionValues(a.source, b.source, direction)
      );
    default:
      return dependencies;
  }
};
